export default {"src":"/_next/static/media/minus_regular.b151e435.svg","height":24,"width":24};